import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import ForumIcon from "@mui/icons-material/Forum";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import TimelineIcon from "@mui/icons-material/Timeline";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import GroupsIcon from "@mui/icons-material/Groups";

export const FLOW_HUB_CAROUSEL_ICONS_CONFIG = {
  streamlinedQuoteRequests: <RequestQuoteIcon />,
  dynamicWorkforceManagement: <Diversity3Icon />,
  integratedLandingPageDesign: <DashboardCustomizeIcon />,
  smartClientManagement: <ManageAccountsIcon />,
  automatedBillingInvoicing: <ReceiptLongIcon />,
  realTimeAnalyticsDashboard: <QueryStatsIcon />,
  unifiedCommunicationHub: <ForumIcon />,
  roleBasedAccessControl: <AdminPanelSettingsIcon />,
  fileAssetSharing: <FolderSharedIcon />,
  milestoneDeadlineTracking: <TimelineIcon />,
  automatedStatusReminders: <NotificationsActiveIcon />,
  resourceAllocationPlanner: <GroupsIcon />,
};
